/**
 * Share a link from the Mini App. Prefers Telegram's native share sheet — which
 * works inside the Telegram webview where `navigator.share` is often unavailable —
 * then falls back to the Web Share API, then the clipboard.
 */
import WebApp from '@twa-dev/sdk';

/** The user's public Calestea profile link. Pass the authenticated user's `me.id`. */
export function profileShareUrl(userId: string): string {
  return `https://app.calestea.com/c/${userId}`;
}

function copyToClipboard(text: string): void {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    void navigator.clipboard.writeText(text).catch(() => {});
  }
}

export function shareLink(url: string, text?: string): void {
  const params = new URLSearchParams({ url, ...(text ? { text } : {}) });
  const tgShareUrl = `https://t.me/share/url?${params.toString()}`;

  try {
    if (WebApp?.openTelegramLink) {
      WebApp.openTelegramLink(tgShareUrl);
      return;
    }
  } catch {
    // Not in Telegram (or SDK threw) — fall through to web fallbacks.
  }

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    void navigator.share({ url, ...(text ? { text } : {}) }).catch(() => copyToClipboard(url));
    return;
  }

  copyToClipboard(url);
}
